<template>
	<highcharts :options="reformatOptions"></highcharts>
</template>
<script>
import ChartHelper from 'Mixins/ChartHelper'
export default {
	props: {
		options: {
			type: Object,
			default: () => {
				return {}
			}
		}
	},
	mixins: [ChartHelper],
	data() {
		return {}
	},
	computed: {
		reformatOptions() {
			let roast = this.roast(this.options)
			if ('data' in this.options) {
				roast.series[0]['colorByPoint'] = true
				roast.series[0]['innerSize'] = '75%'
			}
			let chartOptions = {
				...roast,
				chart: {
					plotBackgroundColor: null,
					plotBorderWidth: null,
					plotShadow: false,
					type: 'pie'
				},
				tooltip: {
					pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>'
				},
				accessibility: {
					point: {
						valueSuffix: '%'
					}
				},
				plotOptions: {
					pie: {
						allowPointSelect: true,
						cursor: 'pointer',
						dataLabels: {
							enabled: true,
							format:
								'<b>{point.name}</b>: {point.percentage:.1f} %'
						},
						startAngle: 0,
						endAngle: 360,
						center: ['50%', '60%'],
						size: '90%'
					}
				}
			}
			return chartOptions
		}
	}
}
</script>
